import { makeStyles } from '@material-ui/core/styles'
import { BORDER_WIDTH } from './PDFContainer.const'

const useStyles = makeStyles(
	({ spacing, margins = { bottom: 0, top: 0 }, palette, transitions, showBorders }) => ({
		root: {
			padding: showBorders ? spacing(BORDER_WIDTH) : 0,
			transition: transitions.create(['padding']),
			height: '100%',
			width: '100%',
			display: 'inline-block',
		},
		topBorder: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			height: '50%',
			backgroundColor: palette.common.borderTop,
			zIndex: 0,
		},
		bottomBorder: {
			position: 'absolute',
			bottom: 0,
			left: 0,
			right: 0,
			height: '50%',
			backgroundColor: palette.common.borderBottom,
			zIndex: 0,
		},
		content: {
			display: 'flex',
			flexDirection: 'column',
			height: '100%',
			position: 'relative',
			zIndex: 1,
			backgroundColor: palette.background.default,
			padding: showBorders ? spacing(BORDER_WIDTH, 0, BORDER_WIDTH) : spacing(margins.top, 0, margins.bottom),
			transition: transitions.create(['padding']),
		},
	}),
	{ name: 'Section-PDFContainer' },
)

export default useStyles
